"use strict";

exports.__esModule = true;
exports.DeviceLagContext = void 0;
var _DeviceLagController = require("../DeviceLagController/DeviceLagController");
var _Utils = require("../../../../Utils");
/**
 * Provides Device Lag Status Context to consumers
 * @component
 */

var DeviceLagContext = exports.DeviceLagContext = (0, _Utils.createEnhancedContext)({
  propName: "deviceLag",
  defaultController: _DeviceLagController.DeviceLagController
});